import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OECellTargetType as OECellTargetType_, OECellStartSelectionContent} from './oe-cell-consts';

export const OECellTargetType = OECellTargetType_;

export const OECellTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OECellTargetType.cells]: [
            OETarget.animalCell,
            OETarget.plantCell
        ]
    },
    {
        [OECellTargetType.cells]: OETarget.animalCell,
    },
    {
        [OECellTargetType.cells]: OETarget.animalCell,
    }
);

export const OECellFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            cellsTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.cellsTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OECellTargets);

export const OECellStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OECellTargets,
    OECellStartSelectionContent
);